if (!customElements.get("shipping-notice")) {
  customElements.define(
    "shipping-notice",
    class ShippingNotice extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector("dialog");
        if (!this.dialog || typeof this.dialog.showModal !== "function") return;

        this.key = this.dataset.key;
        this.frequency = this.dataset.frequency || "session";
        this.preview = this.dataset.designMode === "true";

        if (!this.preview && this.isDismissed()) return;

        const closeButton = this.querySelector("[data-notice-close]");
        if (closeButton) {
          closeButton.addEventListener("click", () => this.dismiss());
        }

        // Esc counts as a dismissal, so cancel the native close and route it
        // through dismiss() to make sure the flag gets written.
        this.dialog.addEventListener("cancel", (event) => {
          event.preventDefault();
          this.dismiss();
        });

        // Some embedded webviews (in-app browsers) never turn an Esc keypress
        // into a close request, so "cancel" above never fires there.
        this.dialog.addEventListener("keydown", (event) => {
          if (event.key !== "Escape" && event.key !== "Esc") return;
          if (!this.dialog.open) return;
          event.preventDefault();
          this.dismiss();
        });

        // Hand focus back to the page once the dialog is gone.
        this.dialog.addEventListener("close", () => {
          const active = document.activeElement;
          if (active && active !== document.body && this.contains(active)) {
            active.blur();
          }
        });

        const delay = parseInt(this.dataset.delay, 10) || 0;

        this.whenConsentResolved(() => {
          window.setTimeout(() => {
            if (this.isConnected && !this.dialog.open) this.dialog.showModal();
          }, delay);
        });
      }

      // A consent banner is not in the browser top layer, so a modal dialog
      // would paint over it. Let the visitor answer consent first.
      whenConsentResolved(callback) {
        if (this.preview) {
          callback();
          return;
        }

        let pending = false;
        try {
          const api = window.Shopify && window.Shopify.customerPrivacy;
          const banner = document.getElementById("shopify-pc__banner");
          pending = !!(
            (banner && banner.offsetParent !== null) ||
            (api &&
              typeof api.shouldShowBanner === "function" &&
              api.shouldShowBanner())
          );
        } catch (e) {
          pending = false;
        }

        if (!pending) {
          callback();
          return;
        }

        document.addEventListener("visitorConsentCollected", callback, {
          once: true,
        });
      }

      store() {
        if (this.frequency === "every_page") return null;
        try {
          return this.frequency === "once"
            ? window.localStorage
            : window.sessionStorage;
        } catch (e) {
          return null;
        }
      }

      isDismissed() {
        const store = this.store();
        if (!store) return false;
        try {
          return store.getItem(this.key) === "1";
        } catch (e) {
          return false;
        }
      }

      dismiss() {
        if (!this.preview) {
          const store = this.store();
          if (store) {
            try {
              store.setItem(this.key, "1");
            } catch (e) {
              /* storage blocked or full: close anyway */
            }
          }
        }
        this.dialog.close();
      }
    },
  );
}